namespace Gamification.Gamification {
    export class ProdottiClassiCheckColumns {
        static columnsKey = 'Gamification.ProdottiClassiCheck';
    }
}
